import React, { FC } from 'react';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Box, PaginationItem, Button } from '@mui/material';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import StyledPagination from 'views/rebranded-module/common/components/UI/Pagination/Pagination.styles';

interface PaginationProps {
  data: {
    active_page: number;
    pages_count: number;
  };
  url: string;
  link?: string;
  handleChange: (page: number) => void;
}

const Pagination: FC<PaginationProps> = ({
  data,
  url,
  link,
  handleChange,
}) => {
  const { active_page, pages_count } = data;

  return (
    <StyledPagination
      page={active_page}
      count={pages_count}
      variant="outlined"
      shape="rounded"
      boundaryCount={1}
      siblingCount={0}
      onChange={(_, page) => handleChange(page)}
      renderItem={(item) => {
        // Disable previous button on first page
        if (item.type === 'previous') {
          const disabled = active_page === 1;
          return (
            <PaginationItem
              className="ERPItem"
              component={link ? NavigatorLink : Button}
              to={link ? `${url}?page=${item.page}` : undefined}
              onClick={() => !link && handleChange(item.page)}
              disabled={disabled}
              {...item}
            >
              <Box display="flex" alignItems="center">
                <ArrowRightAltIcon sx={{ transform: 'rotate(180deg)' }} />
              </Box>
            </PaginationItem>
          );
        }

        // Disable next button on last page
        if (item.type === 'next') {
          const disabled = active_page === pages_count;
          return (
            <PaginationItem
              className="ERPItem"
              component={link ? NavigatorLink : Button}
              to={link ? `${url}?page=${item.page}` : undefined}
              onClick={() => !link && handleChange(item.page)}
              disabled={disabled}
              {...item}
            >
              <Box display="flex" alignItems="center">
                <ArrowRightAltIcon />
              </Box>
            </PaginationItem>
          );
        }

        if (item.type === 'start-ellipsis' || item.type === 'end-ellipsis') {
          return (
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              …
            </Box>
          );
        }

        return (
          <PaginationItem
            className="ERPItem"
            component={link ? NavigatorLink : Button}
            to={link ? `${url}?page=${item.page}` : undefined}
            onClick={() => !link && handleChange(item.page)}
            {...item}
          />
        );
      }}
    />
  );
};

export { Pagination };